import React, { useState } from "react";
import "./Careers.css";
import Footer from "../Footer/Footer";
import WhatsAppIcon from "../../WhatsAppComponent/WhatsAppIcon";

/* ──────────────────────────────────────────────
   JOB DATA  (Updated June 2026)
────────────────────────────────────────────── */
const jobListings = [
  // ── 1. Engineering & Design ──
  {
    id: "engineering-design",
    title: "Engineering & Design",
    category: "Engineering & Design",
    vacancies: [
      {
        location: "Bangalore – CUTTECH R&D Unit",
        count: 3,
      },
    ],
    qualification: ["B.E. Mechanical Engineering"],
    experience: "6+ Years",
    roles: [
      "Cutting Tool Design Engineer",
      "Special Tool Design Engineer",
      "CAD/CAM Engineer",
      "Reverse Engineering Engineer",
      "Product Development Engineer",
      "R&D Engineer",
    ],
    skills: [
      "SolidWorks / CATIA / AutoCAD – 3D Modeling & Drafting",
      "Cutting tool geometry and design fundamentals",
      "Tool material and coating knowledge",
      "GD&T interpretation and engineering drawing preparation",
      "Product development and design validation",
      "Reverse engineering and BOM documentation",
    ],
  },
  // ── 2. Manufacturing & Production ──
  {
    id: "manufacturing-production",
    title: "Manufacturing & Production",
    category: "Manufacturing & Production",
    vacancies: [
      {
        location: "Bangalore – CUTTECH R&D Unit",
        count: null,
      },
    ],
    qualification: ["Diploma in Mechanical Engineering", "ITI Fitter"],
    experience: "2+ Years",
    roles: [
      "CNC Tool Grinding Operator",
      "CNC Programmer",
      "Production Engineer",
      "Process Engineer",
      "Tool Room Engineer",
      "Manufacturing Supervisor",
    ],
    skills: [
      "CNC machining and tool grinding operations",
      "G-Code / M-Code programming",
      "Production planning and scheduling",
      "Process optimization and shop floor management",
      "Knowledge of Lean Manufacturing, 5S, Kaizen",
      "Fixture and tooling knowledge",
    ],
  },
  // ── 3. Quality & Inspection ──
  {
    id: "quality-inspection",
    title: "Quality & Inspection",
    category: "Quality & Inspection",
    vacancies: [
      {
        location: "Bangalore – CUTTECH R&D Unit",
        count: null,
      },
    ],
    qualification: [
      "B.E. Mechanical Engineering",
      "Diploma in Mechanical Engineering",
    ],
    experience: "1+ Year",
    roles: [
      "Quality Engineer",
      "CMM Inspection Engineer",
      "Metrology Engineer",
      "Quality Assurance Executive",
    ],
    skills: [
      "Incoming, In-process, and Final Inspection",
      "Precision instruments: Vernier, Micrometer, Bore Gauge, Height Gauge",
      "CMM fundamentals and operation",
      "Root Cause Analysis and Quality Documentation",
      "ISO Standards and Quality Systems",
      "Engineering Drawing Interpretation & GD&T",
    ],
  },
  // ── 4. Sales & Business Development ──
  {
    id: "sales-business-development",
    title: "Sales & Business Development",
    category: "Sales & Business Development",
    vacancies: [
      {
        location: "Multiple Locations",
        count: null,
      },
    ],
    qualification: ["B.E. Mechanical Engineering"],
    experience: "8+ Years in Technical Sales",
    roles: [
      "Technical Sales Engineer",
      "Area Sales Manager",
      "Business Development Executive",
      "Dealer Development Manager",
      "Application Engineer",
    ],
    skills: [
      "Technical sales in cutting tools / industrial products",
      "Customer requirement analysis and relationship management",
      "Tool selection and application support",
      "Territory and dealer network management",
      "Engineering drawing interpretation",
      "Strong communication in English and regional language",
    ],
  },
  // ── 5. Supply Chain & Operations ──
  {
    id: "supply-chain-operations",
    title: "Supply Chain & Operations",
    category: "Supply Chain & Operations",
    vacancies: [
      {
        location: "Bangalore – CUTTECH R&D Unit",
        count: null,
      },
    ],
    qualification: [
      "B.E. / Diploma in Mechanical Engineering",
      "Any relevant degree",
    ],
    experience: "2+ Years",
    roles: [
      "Purchase Engineer",
      "Vendor Development Engineer",
      "Stores & Inventory Executive",
      "Logistics Coordinator",
    ],
    skills: [
      "Vendor development and procurement",
      "Inventory management and material planning",
      "Logistics coordination and delivery tracking",
      "Cost analysis and sourcing strategies",
      "ERP / inventory software knowledge",
    ],
  },
  // ── 6. Corporate Functions ──
  {
    id: "corporate-functions",
    title: "Corporate Functions",
    category: "Corporate Functions",
    vacancies: [
      {
        location: "Bangalore – CUTTECH R&D Unit",
        count: null,
      },
    ],
    qualification: ["Any relevant degree / specialization"],
    experience: "1+ Year",
    roles: [
      "HR Executive",
      "Accounts & Finance Executive",
      "Digital Marketing Executive",
      "Customer Support Executive",
    ],
    skills: [
      "Role-specific domain expertise",
      "Strong written and verbal communication",
      "Proficiency in relevant tools (Tally, MS Office, design tools, CRM, etc.)",
      "Team collaboration and problem-solving",
    ],
  },
];

const categoryColors = {
  "Engineering & Design": "#6495ED",
  "Manufacturing & Production": "#e07b54",
  "Quality & Inspection": "#4caf82",
  "Sales & Business Development": "#f9d342",
  "Supply Chain & Operations": "#9b59b6",
  "Corporate Functions": "#1abc9c",
};

/* ──────────────────────────────────────────────
   INTERNSHIP DOMAINS
────────────────────────────────────────────── */
const internshipDomains = [
  "Cutting Tool Design & Development",
  "Automotive Component Design",
  "Aerospace Component Design",
  "Defense Component Design",
  "CAD Design & Product Development",
  "CNC Programming",
  "Production Engineering",
  "Manufacturing Engineering",
  "Quality Assurance & Inspection",
  "GD&T (Geometric Dimensioning & Tolerancing)",
  "Material Science & Metallurgy",
  "Research & Development (R&D)",
  "Industry 4.0 & Smart Manufacturing",
  "Foundry & Casting Technology",
  "Welding & Fabrication Engineering",
  "Technical Sales & Application Engineering",
  "Supply Chain & Industrial Procurement",
];

/* ──────────────────────────────────────────────
   EMAILJS — TWO SEPARATE TEMPLATE IDs
────────────────────────────────────────────── */
const EMAILJS_SERVICE_ID = "service_a2x52bd"; // same service for both
const EMAILJS_PUBLIC_KEY = "a3_nnEx7ntz6Foiqn";

const TEMPLATE_ID_JOB = "template_oy1ucm7"; // ← Job Application template
const TEMPLATE_ID_INTERNSHIP = "template_yg57mff"; // ← Internship Application template (replace with yours)

async function sendEmailJS(templateId, templateParams) {
  const response = await fetch("https://api.emailjs.com/api/v1.0/email/send", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      service_id: EMAILJS_SERVICE_ID,
      template_id: templateId,
      user_id: EMAILJS_PUBLIC_KEY,
      template_params: templateParams,
    }),
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("EmailJS Error:", text);
    throw new Error(text);
  }
  return true;
}

/* ──────────────────────────────────────────────
   JOB CARD COMPONENT
────────────────────────────────────────────── */
const JobCard = ({ job, onApply }) => {
  const [expanded, setExpanded] = useState(false);
  const color = categoryColors[job.category] || "#f9d342";
  const totalCount = job.vacancies.reduce((s, v) => s + (v.count || 0), 0);

  return (
    <div className="job-card">
      <div className="job-card-header">
        <span
          className="job-category-tag"
          style={{
            backgroundColor: color === "#f9d342" ? "#f9d342" : color + "22",
            color: color === "#f9d342" ? "#000" : color,
            border: `1px solid ${color}`,
          }}
        >
          {job.category}
        </span>
        {totalCount > 0 && (
          <span className="job-vacancies-badge">
            {totalCount} Opening{totalCount !== 1 ? "s" : ""}
          </span>
        )}
      </div>

      <h3 className="job-title">{job.title}</h3>

      <div className="job-locations">
        {job.vacancies.map((v, i) => (
          <span key={i} className="location-chip">
            📍 {v.location}
            {v.count ? ` (${v.count})` : ""}
            {v.note ? ` – ${v.note}` : ""}
          </span>
        ))}
      </div>

      <div className="job-meta">
        <div className="job-meta-item">
          <span className="meta-label">Experience</span>
          <span className="meta-value">{job.experience}</span>
        </div>
        <div className="job-meta-item">
          <span className="meta-label">Qualification</span>
          <span className="meta-value">{job.qualification[0]}</span>
        </div>
      </div>

      {expanded && (
        <div className="job-details-expanded">
          {job.roles && (
            <div className="detail-block">
              <h4>Roles Available</h4>
              <ul>
                {job.roles.map((r, i) => (
                  <li key={i}>{r}</li>
                ))}
              </ul>
            </div>
          )}
          <div className="detail-block">
            <h4>Skills Required</h4>
            <ul>
              {job.skills.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ul>
          </div>
          <div className="detail-block">
            <h4>Qualifications</h4>
            <ul>
              {job.qualification.map((q, i) => (
                <li key={i}>{q}</li>
              ))}
            </ul>
          </div>
        </div>
      )}

      <div className="job-card-actions">
        <button className="btn-expand" onClick={() => setExpanded(!expanded)}>
          {expanded ? "Show Less ▲" : "View Details ▼"}
        </button>
        <button className="btn-apply" onClick={() => onApply(job)}>
          Apply Now →
        </button>
      </div>
    </div>
  );
};

/* ──────────────────────────────────────────────
   APPLICATION MODAL
────────────────────────────────────────────── */
const ApplicationModal = ({ job, internship = false, onClose }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    currentLocation: "",
    totalExperience: "",
    currentCTC: "",
    expectedCTC: "",
    noticePeriod: "",
    desiredRole: "",
    college: "",
    branch: "",
    yearOfPassing: "",
    internshipArea: "",
    message: "",
  });
  const [status, setStatus] = useState("idle");

  const handle = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      if (internship) {
        await sendEmailJS(TEMPLATE_ID_INTERNSHIP, {
          type: "Internship Application",
          position: "Industrial Internship Program",
          applicant_name: form.name,
          applicant_email: form.email,
          applicant_phone: form.phone,
          current_location: form.currentLocation,
          college: form.college,
          branch: form.branch,
          year_of_passing: form.yearOfPassing,
          internship_area: form.internshipArea,
          message: form.message,
          to_email: "cuttechtools@gmail.com",
        });
      } else {
        await sendEmailJS(TEMPLATE_ID_JOB, {
          type: "Job Application",
          position: job.title,
          desired_role: form.desiredRole,
          applicant_name: form.name,
          applicant_email: form.email,
          applicant_phone: form.phone,
          current_location: form.currentLocation,
          experience: form.totalExperience,
          current_ctc: form.currentCTC,
          expected_ctc: form.expectedCTC,
          notice_period: form.noticePeriod,
          message: form.message,
          to_email: "cuttechtools@gmail.com",
        });
      }
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  return (
    <div
      className="modal-backdrop"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="modal-box">
        <button className="modal-close" onClick={onClose}>
          ✕
        </button>

        <div className="modal-header">
          <span className="modal-type-tag">
            {internship ? "Internship" : "Job"} Application
          </span>
          <h2>{internship ? "Industrial Internship Program" : job.title}</h2>
          {!internship && (
            <p className="modal-subtitle">
              {job.vacancies.map((v) => v.location).join(" · ")}
            </p>
          )}
        </div>

        {status === "success" ? (
          <div className="modal-success">
            <div className="success-icon">✓</div>
            <h3>Application Submitted!</h3>
            <p>
              Thank you, <strong>{form.name}</strong>. Your application has been
              received and sent to the CUTTECH team. We will be in touch soon.
            </p>
            <button className="btn-apply" onClick={onClose}>
              Close
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="app-form">
            <div className="form-section-title">Personal Information</div>

            <div className="form-row">
              <div className="form-group">
                <label>Full Name *</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={handle}
                  required
                  placeholder="Your full name"
                />
              </div>
              <div className="form-group">
                <label>Email Address *</label>
                <input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handle}
                  required
                  placeholder="your@email.com"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Phone Number *</label>
                <input
                  name="phone"
                  type="tel"
                  value={form.phone}
                  onChange={handle}
                  required
                  placeholder="+91 XXXXX XXXXX"
                />
              </div>
              <div className="form-group">
                <label>Current Location *</label>
                <input
                  name="currentLocation"
                  value={form.currentLocation}
                  onChange={handle}
                  required
                  placeholder="City, State"
                />
              </div>
            </div>

            {internship ? (
              <>
                <div className="form-section-title">Academic Details</div>
                <div className="form-row">
                  <div className="form-group">
                    <label>College / University *</label>
                    <input
                      name="college"
                      value={form.college}
                      onChange={handle}
                      required
                      placeholder="Your institution"
                    />
                  </div>
                  <div className="form-group">
                    <label>Branch / Specialization *</label>
                    <input
                      name="branch"
                      value={form.branch}
                      onChange={handle}
                      required
                      placeholder="e.g. Mechanical Engineering"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Year of Passing *</label>
                    <select
                      name="yearOfPassing"
                      value={form.yearOfPassing}
                      onChange={handle}
                      required
                    >
                      <option value="">Select year</option>
                      {[2024, 2025, 2026, 2027, 2028].map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Internship Domain *</label>
                    <select
                      name="internshipArea"
                      value={form.internshipArea}
                      onChange={handle}
                      required
                    >
                      <option value="">Select domain</option>
                      {internshipDomains.map((d) => (
                        <option key={d} value={d}>
                          {d}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="form-section-title">Professional Details</div>

                {/* Desired Role dropdown from job.roles */}
                {job.roles && (
                  <div className="form-row">
                    <div className="form-group full-width">
                      <label>Desired Role *</label>
                      <select
                        name="desiredRole"
                        value={form.desiredRole}
                        onChange={handle}
                        required
                      >
                        <option value="">Select a role</option>
                        {job.roles.map((r) => (
                          <option key={r} value={r}>
                            {r}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                <div className="form-row">
                  <div className="form-group">
                    <label>Total Experience *</label>
                    <input
                      name="totalExperience"
                      value={form.totalExperience}
                      onChange={handle}
                      required
                      placeholder="e.g. 4 Years 6 Months"
                    />
                  </div>
                  <div className="form-group">
                    <label>Notice Period *</label>
                    <select
                      name="noticePeriod"
                      value={form.noticePeriod}
                      onChange={handle}
                      required
                    >
                      <option value="">Select notice period</option>
                      <option value="Immediate / Serving Notice">
                        Immediate / Serving Notice
                      </option>
                      <option value="15 Days">15 Days</option>
                      <option value="30 Days">30 Days</option>
                      <option value="45 Days">45 Days</option>
                      <option value="60 Days">60 Days</option>
                      <option value="90 Days">90 Days</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Current CTC (LPA) *</label>
                    <input
                      name="currentCTC"
                      value={form.currentCTC}
                      onChange={handle}
                      required
                      placeholder="e.g. 4 LPA"
                    />
                  </div>
                  <div className="form-group">
                    <label>Expected CTC (LPA) *</label>
                    <input
                      name="expectedCTC"
                      value={form.expectedCTC}
                      onChange={handle}
                      required
                      placeholder="e.g. 5.5 LPA"
                    />
                  </div>
                </div>
              </>
            )}

            <div className="form-section-title">Additional Information</div>
            <div className="form-group full-width">
              <label>Cover Note / Message</label>
              <textarea
                name="message"
                value={form.message}
                onChange={handle}
                rows={4}
                placeholder={
                  internship
                    ? "Tell us why you're interested in this internship and what you hope to learn..."
                    : "Any additional information about your experience or why you're interested in this role..."
                }
              />
            </div>

            {status === "error" && (
              <div className="form-error-msg">
                ⚠️ There was an error sending your application. Please email us
                directly at{" "}
                <a href="mailto:cuttechtools@gmail.com">
                  cuttechtools@gmail.com
                </a>
              </div>
            )}

            <div className="form-actions">
              <button type="button" className="btn-expand" onClick={onClose}>
                Cancel
              </button>
              <button
                type="submit"
                className="btn-apply"
                disabled={status === "sending"}
              >
                {status === "sending" ? "Sending..." : "Submit Application →"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

/* ──────────────────────────────────────────────
   MAIN CAREERS PAGE
────────────────────────────────────────────── */
const Careers = () => {
  const [activeTab, setActiveTab] = useState("jobs");
  const [selectedJob, setSelectedJob] = useState(null);
  const [showInternshipModal, setShowInternshipModal] = useState(false);
  const [filterCategory, setFilterCategory] = useState("All");

  const categories = [
    "All",
    ...Array.from(new Set(jobListings.map((j) => j.category))),
  ];
  const filteredJobs =
    filterCategory === "All"
      ? jobListings
      : jobListings.filter((j) => j.category === filterCategory);

  return (
    <div className="careers-wrapper">
      {/* HERO */}
      <section className="careers-hero">
        <div className="careers-hero-content">
          <span className="hero-eyebrow">JOIN OUR TEAM</span>
          <h1>
            Build Your Future With
            <br />
            <span className="hero-highlight">CUTTECH Solutions</span>
          </h1>
          <p>
            Work on cutting-edge industrial technologies, collaborate with
            experienced professionals, and grow your career in the heart of
            manufacturing excellence.
          </p>
          <div className="hero-stats">
            <div className="hero-stat">
              <span className="stat-num">14+</span>
              <span className="stat-label">Years Experience</span>
            </div>
            <div className="hero-stat-divider" />
            <div className="hero-stat">
              <span className="stat-num">25+</span>
              <span className="stat-label">Open Positions</span>
            </div>
            <div className="hero-stat-divider" />
            <div className="hero-stat">
              <span className="stat-num">6</span>
              <span className="stat-label">Departments</span>
            </div>
          </div>
        </div>
      </section>

      {/* TABS */}
      <div className="careers-tabs-bar">
        <div className="careers-tabs">
          <button
            className={`careers-tab ${activeTab === "jobs" ? "active" : ""}`}
            onClick={() => setActiveTab("jobs")}
          >
            Job Openings
          </button>
          <button
            className={`careers-tab ${activeTab === "internship" ? "active" : ""}`}
            onClick={() => setActiveTab("internship")}
          >
            Internship Program
          </button>
          <button
            className={`careers-tab ${activeTab === "culture" ? "active" : ""}`}
            onClick={() => setActiveTab("culture")}
          >
            Our Culture
          </button>
        </div>
      </div>

      <div className="careers-body">
        {/* ── JOBS TAB ── */}
        {activeTab === "jobs" && (
          <div className="jobs-section">
            <div className="section-header">
              <h2>Current Openings</h2>
              <p>
                Explore opportunities across engineering, sales, quality, and
                operations.
              </p>
            </div>

            <div className="filter-bar">
              <span className="filter-label">Filter by:</span>
              {categories.map((cat) => (
                <button
                  key={cat}
                  className={`filter-chip ${filterCategory === cat ? "active" : ""}`}
                  onClick={() => setFilterCategory(cat)}
                  style={
                    filterCategory === cat && cat !== "All"
                      ? {
                          backgroundColor: categoryColors[cat] || "#f9d342",
                          color:
                            cat === "Sales & Business Development"
                              ? "#000"
                              : "#fff",
                          borderColor: categoryColors[cat] || "#f9d342",
                        }
                      : {}
                  }
                >
                  {cat}
                </button>
              ))}
            </div>

            <div className="jobs-grid">
              {filteredJobs.map((job) => (
                <JobCard key={job.id} job={job} onApply={setSelectedJob} />
              ))}
            </div>

            <div className="preferred-competencies">
              <h3>Preferred Additional Competencies (All Roles)</h3>
              <div className="competencies-grid">
                {[
                  "Strong technical aptitude",
                  "Team leadership abilities",
                  "Problem-solving and analytical skills",
                  "Knowledge of ERP systems (added advantage)",
                  "Good communication skills in English and local language",
                  "Willingness to travel when required",
                ].map((c, i) => (
                  <div key={i} className="competency-chip">
                    ✦ {c}
                  </div>
                ))}
              </div>
              <p className="how-to-apply">
                Interested candidates send resume with:{" "}
                <strong>
                  Current Location · Total Experience · Current CTC · Expected
                  CTC · Notice Period
                </strong>{" "}
                to{" "}
                <a href="mailto:cuttechtools@gmail.com">
                  cuttechtools@gmail.com
                </a>
              </p>
            </div>
          </div>
        )}

        {/* ── INTERNSHIP TAB ── */}
        {activeTab === "internship" && (
          <div className="internship-section">
            <div className="section-header">
              <h2>Industrial Internship Program</h2>
              <p>
                A hands-on program designed to bridge the gap between academic
                education and practical industrial requirements — developing
                future engineers for Indias manufacturing revolution. 🇮🇳
              </p>
            </div>

            <div className="leadership-cards">
              <div className="leader-card">
                <div className="leader-avatar">SG</div>
                <div className="leader-info">
                  <h3>Mr. Srinivas Govindaiah</h3>
                  <span className="leader-role">
                    Production Partner & Technical Educator
                  </span>
                  <p>
                    Mechanical Engineer with over three decades of industrial
                    experience in manufacturing, production engineering, process
                    development, and industrial operations. Dedicated to
                    mentoring the next generation of engineers.
                  </p>
                </div>
              </div>
              <div className="leader-card">
                <div className="leader-avatar">KA</div>
                <div className="leader-info">
                  <h3>Mr. Keerthisagar A M</h3>
                  <span className="leader-role">
                    Marketing & Technical Sales Partner
                  </span>
                  <p>
                    Mechanical Engineer specializing in Metal Cutting Technology
                    and Material Science. Bridges the gap between engineering
                    innovation and industrial requirements to improve
                    productivity and manufacturing performance.
                  </p>
                </div>
              </div>
            </div>

            {/* INTERNSHIP DOMAINS */}
            <div className="section-header" style={{ marginTop: "2.5rem" }}>
              <h3>Internship Domains</h3>
              <p>
                Choose your area of interest. All domains involve live
                industrial projects and mentorship.
              </p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "18px",
                marginTop: "50px",
              }}
            >
              <h3>Internship Domains</h3>
              <span
                style={{
                  background: "#f9d342",
                  color: "#000",
                  fontSize: "12px",
                  fontWeight: 700,
                  padding: "4px 12px",
                  borderRadius: "20px",
                }}
              >
                {internshipDomains.length} Domains
              </span>
            </div>
            <div className="internship-domains-grid">
              {internshipDomains.map((domain, i) => (
                <div key={i} className="domain-chip">
                  <span className="domain-index">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {domain}
                </div>
              ))}
            </div>

            <div
              className="internship-why-grid"
              style={{ marginTop: "2.5rem" }}
            >
              {[
                {
                  icon: "🏭",
                  title: "Industry-Ready Engineers",
                  desc: "Real-world exposure to manufacturing technologies and engineering practices that bridge academic learning and industry needs.",
                },
                {
                  icon: "⚙️",
                  title: "CNC & CAD/CAM Hands-On",
                  desc: "Practical experience in CNC machining, CAD/CAM, quality inspection, production planning, and material science.",
                },
                {
                  icon: "🇮🇳",
                  title: "Make in India Initiative",
                  desc: "Prepares engineers for aerospace, automotive, defense, locomotive, and precision engineering industries.",
                },
                {
                  icon: "📊",
                  title: "Live Industrial Projects",
                  desc: "Participate in projects focused on productivity improvement, cost reduction, process optimization, and tool-life enhancement.",
                },
                {
                  icon: "🤝",
                  title: "Industry-Academia Link",
                  desc: "Strong connection between educational institutions and industry to understand current challenges and expectations.",
                },
                {
                  icon: "🏆",
                  title: "Certified Outcome",
                  desc: "Completion Certificate, Industrial Skill Assessment Report, Project Certificate, and Recommendation Letter for outstanding performance.",
                },
              ].map((item, i) => (
                <div key={i} className="intern-why-card">
                  <span className="intern-icon">{item.icon}</span>
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="intern-benefits-section">
              <h3>Key Benefits for Students</h3>
              <div className="benefits-list">
                {[
                  "Hands-on CNC Programming and Machining Experience",
                  "Exposure to CAD/CAM Software and Product Design",
                  "Practical Knowledge of GD&T and Metrology",
                  "Understanding of Quality Systems and Inspection Techniques",
                  "Experience in Aerospace, Automotive, and Defense Manufacturing",
                  "Live Industrial Project Participation",
                  "Manufacturing Plant Visit & Machine Demonstrations",
                  "Professional Skill Development and Industry Readiness",
                  "Industry-Recognized Internship Completion Certificate",
                  "Industrial Skill Assessment Report",
                  "Recommendation Letter for Outstanding Performance",
                  "Career Guidance & Technical Development",
                ].map((b, i) => (
                  <div key={i} className="benefit-item">
                    <span className="benefit-check">✓</span>
                    {b}
                  </div>
                ))}
              </div>
            </div>

            <div className="internship-cta">
              <p>Ready to gain real-world industrial experience?</p>
              <button
                className="btn-apply large"
                onClick={() => setShowInternshipModal(true)}
              >
                Apply for Internship →
              </button>
            </div>
          </div>
        )}

        {/* ── CULTURE TAB ── */}
        {activeTab === "culture" && (
          <div className="culture-section">
            <div className="section-header">
              <h2>Our Culture</h2>
              <p>
                At CUTTECH Solutions, we foster an environment where innovation
                and integrity drive everything we do.
              </p>
            </div>

            <div className="culture-values-grid">
              {[
                {
                  icon: "💡",
                  value: "Innovation",
                  desc: "We encourage every employee to contribute ideas, challenge conventions, and push the boundaries of engineering excellence.",
                },
                {
                  icon: "🤝",
                  value: "Integrity",
                  desc: "Honesty, transparency, and ethical conduct are the foundation of every relationship — with colleagues, customers, and partners.",
                },
                {
                  icon: "👥",
                  value: "Teamwork",
                  desc: "Collaboration across disciplines creates solutions no individual could achieve alone. We win together.",
                },
                {
                  icon: "🎯",
                  value: "Accountability",
                  desc: "We take ownership of our work, our decisions, and our outcomes. Every promise is a commitment.",
                },
                {
                  icon: "📈",
                  value: "Continuous Improvement",
                  desc: "Learning never stops. We invest in our people through training, certifications, and career growth pathways.",
                },
              ].map((v, i) => (
                <div key={i} className="value-card">
                  <span className="value-icon">{v.icon}</span>
                  <h3>{v.value}</h3>
                  <p>{v.desc}</p>
                </div>
              ))}
            </div>

            <div className="benefits-strip">
              <h3>Employee Benefits</h3>
              <div className="benefits-strip-grid">
                {[
                  "Competitive compensation",
                  "Performance-based incentives",
                  "Professional development opportunities",
                  "Technical training and certifications",
                  "Career advancement pathways",
                  "Supportive and collaborative work environment",
                ].map((b, i) => (
                  <div key={i} className="strip-benefit">
                    <span className="strip-check">★</span>
                    {b}
                  </div>
                ))}
              </div>
            </div>

            <div className="hiring-process">
              <h3>Recruitment Process</h3>
              <div className="process-steps">
                {[
                  {
                    step: "01",
                    title: "Application Submission",
                    desc: "Submit your resume and supporting documents via the Apply button.",
                  },
                  {
                    step: "02",
                    title: "Initial Screening",
                    desc: "The General Manager reviews applications. Shortlisted candidates are contacted.",
                  },
                  {
                    step: "03",
                    title: "Technical Evaluation",
                    desc: "Role-specific assessment or professional discussion to evaluate technical competence.",
                  },
                  {
                    step: "04",
                    title: "Interview",
                    desc: "Meeting with the General Manager and relevant team members.",
                  },
                  {
                    step: "05",
                    title: "Offer & Onboarding",
                    desc: "Successful candidates receive an offer letter and full onboarding support.",
                  },
                ].map((s, i) => (
                  <div key={i} className="process-step">
                    <div className="step-number">{s.step}</div>
                    <div className="step-content">
                      <h4>{s.title}</h4>
                      <p>{s.desc}</p>
                    </div>
                    {i < 4 && <div className="step-connector" />}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* MODALS */}
      {selectedJob && (
        <ApplicationModal
          job={selectedJob}
          onClose={() => setSelectedJob(null)}
        />
      )}
      {showInternshipModal && (
        <ApplicationModal
          internship
          job={null}
          onClose={() => setShowInternshipModal(false)}
        />
      )}

      <Footer />
      <WhatsAppIcon />
    </div>
  );
};

export default Careers;
